(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["wissam-promotions"] && !Shopify.designMode) return;
  try {
    
  function syncWissamBentoServices() {
    document.querySelectorAll('[data-wissam-bento-host]').forEach((host) => {
      const stack = host.querySelector('[data-wissam-bento-stack]');
      if (!stack) return;

      const sectionWrapper = host.closest('.shopify-section');
      let serviceTemplate = sectionWrapper && sectionWrapper.nextElementSibling
        ? sectionWrapper.nextElementSibling.querySelector('template[data-wissam-bento-service-template]')
        : null;

      if (!serviceTemplate) {
        serviceTemplate = document.querySelector('template[data-wissam-bento-service-template]');
      }

      if (!serviceTemplate) return;

      stack.querySelectorAll('[data-wissam-bento-clone]').forEach((node) => node.remove());

      const fragment = serviceTemplate.content.cloneNode(true);
      fragment.querySelectorAll('[data-wissam-service-card]').forEach((card) => {
        card.setAttribute('data-wissam-bento-clone', '');
      });
      stack.appendChild(fragment);
      host.classList.add('is-bento-ready');
    });
  }

  syncWissamBentoServices();
  document.addEventListener('DOMContentLoaded', syncWissamBentoServices, { once: true });
  document.addEventListener('shopify:section:load', () => requestAnimationFrame(syncWissamBentoServices));
  document.addEventListener('shopify:section:reorder', () => requestAnimationFrame(syncWissamBentoServices));

  } catch(e) { console.error(e); }
})();
})();
